import * as React from 'react';

import { BxDesktopBx1106RedesignRecsExperiment } from '../../constants/experimentsAb';

type TDesktopRedesignRecommendationsExperimentProps = {
  legacy: React.ReactNode;
  redesigned: React.ReactNode;
};

export const DesktopRedesignRecommendationsExperiment: React.FC<TDesktopRedesignRecommendationsExperimentProps> = ({
  legacy,
  redesigned,
}) => (
  <BxDesktopBx1106RedesignRecsExperiment>
    <BxDesktopBx1106RedesignRecsExperiment.Group name="A">{legacy}</BxDesktopBx1106RedesignRecsExperiment.Group>
    <BxDesktopBx1106RedesignRecsExperiment.Group name="B">{redesigned}</BxDesktopBx1106RedesignRecsExperiment.Group>
  </BxDesktopBx1106RedesignRecsExperiment>
);
